export class Alert {
    id: string;
    type: string;
    message: string;
    keepAfterRouteChange: boolean;
    dismissible: boolean;
    dismissOnTimeout: number;
    fade: boolean;

    constructor(init?:Partial<Alert>) {
        Object.assign(this, init);
    }
}